import { ApiUnauthorizedError, ApiTimeoutError, ApiNetworkError } from '../services/claimsApi'

// The ad-hoc contact proc rejects a repeated name+email pair (Msg 105). The form's own
// pre-check and the save hook both use this wording, so the user reads one message
// wherever the duplicate was caught.
export const DUPLICATE_ADHOC_CONTACT_MESSAGE = 'This name and email are already on the claim.'

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiUnauthorizedError) return 'Please sign in to continue.'
  if (err instanceof ApiTimeoutError) return (err as Error).message
  if (err instanceof ApiNetworkError) return (err as Error).message
  return fallback
}

// Office.js reports a blocked calendar as a generic failure with a host-worded message,
// so the wording is matched rather than a code — anything unrecognised falls through to
// the retryable message (MSD-684).
const CALENDAR_PERMISSION_PATTERNS = [/permission/i, /denied/i, /not allowed/i, /access/i]

export function getEventReminderErrorMessage(err: unknown): string {
  const raw = err instanceof Error ? err.message : ''
  if (CALENDAR_PERMISSION_PATTERNS.some((p) => p.test(raw))) {
    return 'Outlook did not allow access to your calendar, so the reminder could not be created.'
  }
  return 'Could not open the event reminder. Please try again.'
}

const NETWORK_ERROR_PATTERNS = [/aborted/i, /internal error/i, /network/i, /fetch/i, /failed to fetch/i]

export function getAttachmentActionErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiUnauthorizedError) return 'Please sign in to continue.'
  if (err instanceof ApiTimeoutError || err instanceof ApiNetworkError) return 'Network error. Please try again.'
  if (err instanceof Error && NETWORK_ERROR_PATTERNS.some((p) => p.test(err.message))) {
    return 'Network error. Please try again.'
  }
  return fallback
}
